import styled, { css, createGlobalStyle } from 'styled-components';

import colors from './colors';
import device from './device';

export const BaseWrapper = styled.div``;

export const WrapperDiv = styled(BaseWrapper)``;

export const Spacer = {
  Small: styled(BaseWrapper)`
    margin-bottom: 8px;
  `,
  Medium: styled(BaseWrapper)`
    margin-bottom: 16px;
  `,
  Large: styled(BaseWrapper)`
    margin-bottom: 24px;
  `
};

const baseCSS = css`
  pointer-events: none;
`;

export const fullWidthStyle = css`
  ${baseCSS};
  width: 100%;
  height: auto;
  position: relative;
`;

export const fullHeightStyle = css`
  ${baseCSS};
  width: auto;
  height: 100%;
`;

export const transitionVisible = css`
  /* This timing applies on the way IN */
  transition-timing-function: ease-out;

  /* A litttttle slower on the way in */
  transition: 0.5s;

  /* Move into place */
  transform: translateX(0);
`;

export const transitionHidden = css`
  /* This timing applies on the way OUT */
  transition-timing-function: ease-in;

  /* Quick on the way out */
  transition: 0.5s;

  /* Hide thing by pushing it outside by default */
  transform: translateX(-100%);
`;

export const fadeOut = css`
  visibility: hidden;
  opacity: 0;
  transition: visibility 2s linear 300ms, opacity 0.5s;
  opacity: 0;
  z-index: -1;
`;

export const fadeIn = css`
  visibility: visible;
  opacity: 0.75;
  transition: visibility 0s linear 0s, opacity 0.5s;
  z-index: 9;
  width: 100vw;
  height: 100vh;
`;

export const textFocus = css`
  color: ${colors.brown};
  text-decoration: underline;
`;

interface PreventScroll {
  isEnabled: boolean;
}

export const FixedBody = createGlobalStyle<PreventScroll>`
  body {
    @media ${device.isMobile} {
      ${props => props.isEnabled && css`position: fixed; overflow: hidden; overflow-y: scroll;`}
    }
}`;
